<app-resource-form-card
  [title]="service.title()"
  [resource]="service.resource"
  [resourceId]="value()?._id"
  [saveButton]="saveButton"
  [editButton]="editButton"
  [(loading)]="loading"
  (submit)="submit()"
>
  <div [formGroup]="formGroup" class="form-group">
    <ul>
      @if (value()?._id) {
      <li>
        <div class="label">
          <label>ID</label>
        </div>
        <div class="input">
          {{ value()?._id }}
        </div>
        <div class="button"></div>
      </li>
      }
      <li>
        <div class="label">
          <label [for]="enum.name">Nombre</label>
        </div>
        <div class="input">
          @if (saveButton) {
          <input
            [id]="enum.name"
            [type]="typeEnum.text"
            pInputText
            placeholder="Nombre del Anuncio"
            [formControlName]="enum.name"
          />
          } @else if ((value() !== undefined) && details()) {
          {{ value()?.formattedName }}
          }
        </div>
        <div class="button"></div>
      </li>
      <li>
        <div class="label">
          <label [for]="enum.description">Descripción</label>
        </div>
        <div class="input">
          @if (saveButton) {
          <textarea
            [id]="enum.description"
            [formControlName]="enum.description"
            pInputTextarea
            placeholder="Descripción"
          ></textarea>
          } @else if ((value() !== undefined) && details()) {
          {{ value()?.formattedDescription }}
          }
        </div>
        <div class="button"></div>
      </li>
      @if (access()?.contract?.actions?.read) {
      <li>
        <div class="label">
          <label [for]="enum.contract">Contrato</label>
        </div>
        <div class="input">
          @if (create()) { @defer (when contracts()) {
          <p-dropdown
            [id]="enum.contract"
            [options]="contracts()"
            [required]="true"
            optionLabel="name"
            dataKey="_id"
            placeholder="Selecciona un contrato"
            [formControlName]="enum.contract"
            (onChange)="contractSelect($event)"
          ></p-dropdown>
          } } @else if (value() !== undefined) {
          {{ value()?.formattedContract }}
          }
        </div>
        <div class="button"></div>
      </li>
      } @if (access()?.branch?.actions?.read) {
      <li>
        <div class="label">
          <label [for]="enum.branches">Sucursales</label>
        </div>
        <div class="input">
          @if (create()) { @defer (when branches()) {
          <p-multiSelect
            [id]="enum.branches"
            [formControlName]="enum.branches"
            [options]="branches()"
            optionLabel="name"
            dataKey="_id"
            (onChange)="branchesSelect($event)"
            placeholder="Sucursales"
          />
          } } @else if (value() !== undefined) { @for (branch of
          value()?.branches; track $index) {
          <p-chip [label]="$index + 1 + ' - ' + branch.name" />
          } }
        </div>
        <div class="button">
          <!-- @if (value()?.branch?._id && details()) {
              <button
                pButton
                pRipple
                icon="pi pi-info-circle"
                [title]="value()?.branch?.name + ' details'"
                (click)="routesService.details(resources.branch, value()?.branch?._id)"
              ></button>
            } -->
        </div>
      </li>
      } @if (access()?.image?.actions?.read) {
      <li>
        <div class="label">
          <label [for]="enum.images">Imagenes</label>
        </div>
        <div class="input">
          @if (saveButton) { @defer (when images()) {
          <p-multiSelect
            [id]="enum.images"
            [formControlName]="enum.images"
            [options]="images()"
            optionLabel="name"
            dataKey="_id"
            display="chip"
            placeholder="Selecciona las Imagenes"
          >
            <ng-template let-item pTemplate="item">
              <div class="item-box">
                <!-- <p-image
                  [src]="imageUrlBase + item.path"
                  [alt]="item.name"
                  width="100"
                  [preview]="true"
                /> -->
                @if (service.isImage(item)) {
                <p-image
                  [src]="item.formattedImageURL"
                  [alt]="value.name"
                  width="100"
                  [preview]="false"
                />
                } @else if (service.isVideo(item)) {
                <video
                  [src]="item.formattedImageURL"
                  width="500"
                  class="resource-thumbnail"
                ></video>
                } @else {
                <div class="no-preview-placeholder">
                  <i class="pi pi-file"></i> No hay previsualización
                </div>
                }
                <div>{{ item.name }}</div>
              </div>
            </ng-template>
            <ng-template let-country pTemplate="footer">
              <div class="py-2 px-3">
                <b>
                  {{
                    formGroup.value.images ? formGroup.value.images.length : 0
                  }}
                </b>
                Imagen{{
                  (formGroup.value.images ? formGroup.value.images.length : 0) >
                  1
                    ? "es"
                    : ""
                }}
                seleccionada{{
                  (formGroup.value.images ? formGroup.value.images.length : 0) >
                  1
                    ? "s"
                    : ""
                }}.
              </div>
            </ng-template>
          </p-multiSelect>
          <p-galleria
            [value]="formGroup.value.images ?? []"
            [autoPlay]="true"
            [circular]="true"
            [showIndicators]="false"
            [showThumbnails]="false"
            [showItemNavigators]="true"
            [containerStyle]="{ 'max-width': '640px' }"
            [numVisible]="5"
          >
            <ng-template pTemplate="item" let-item>
              @if (service.isImage(item)) {
              <p-image
                [src]="item.formattedImageURL"
                [alt]="value.name"
                width="500"
                [preview]="true"
              />
              } @else if (service.isVideo(item)) {
              <video
                [src]="item.formattedImageURL"
                controls
                width="500"
                class="resource-thumbnail"
              ></video>
              } @else {
              <div class="no-preview-placeholder">
                <i class="pi pi-file"></i> No hay previsualización
              </div>
              }
            </ng-template>
          </p-galleria>
          } } @else if ((value() !== undefined) && details()) {
          <p-galleria
            [value]="value()?.images"
            [autoPlay]="true"
            [circular]="true"
            [showIndicators]="false"
            [showThumbnails]="false"
            [showItemNavigators]="true"
            [containerStyle]="{ 'max-width': '640px' }"
            [numVisible]="5"
          >
            <ng-template pTemplate="item" let-item>
              <!-- <img [src]="item.itemImageSrc" style="width: 100%;" /> -->
              <!-- <p-image
                [src]="imageUrlBase + item.path"
                [alt]="item.name"
                [preview]="false"
              /> -->
              @if (service.isImage(item)) {
              <p-image
                [src]="item.formattedImageURL"
                [alt]="value.name"
                width="500"
                [preview]="true"
              />
              } @else if (service.isVideo(item)) {
              <video
                [src]="item.formattedImageURL"
                controls
                width="500"
                class="resource-thumbnail"
              ></video>
              } @else {
              <div class="no-preview-placeholder">
                <i class="pi pi-file"></i> No hay previsualización
              </div>
              }
            </ng-template>
          </p-galleria>
          }
        </div>
        <div class="button">
          <!-- @if (create() || edit()) {
              @defer (when images()) {
                <button
                  pButton
                  pRipple
                  label="upload"
                  icon="pi pi-user-edit"
                  (click)="upload()"
                ></button>
              }
            } -->
        </div>
      </li>
      } @if (access()?.user?.actions?.read) {
      <li>
        <div class="label">
          <label [for]="enum.tablets">Pantallas</label>
        </div>
        <div class="input">
          @if (saveButton) { @defer (when display()) {
          <p-multiSelect
            [id]="enum.tablets"
            formControlName="tablets"
            [options]="display()"
            optionLabel="username"
            dataKey="_id"
            placeholder="Selecciona las Pantallas"
          >
            <!-- <ng-template let-country pTemplate="footer">
              <div class="py-2 px-3">
                <b>
                  {{ selectedCountries ? selectedCountries.length : 0 }}
                </b>
                item{{
                  (selectedCountries ? selectedCountries.length : 0) > 1
                    ? "s"
                    : ""
                }}
                selected.
              </div>
            </ng-template> -->
          </p-multiSelect>
          } } @else if ((value() !== undefined) && details()) { @if
          (value()?.tablets) { @for (tablet of value()?.tablets; track $index) {
          <p-chip [label]="$index + 1 + ' - ' + tablet?.username" />
          } } @else {
          {{ "El anuncio no esta asignado a una pantalla" }}
          } }
        </div>
        <div class="button"></div>
      </li>
      }
      <li>
        <div class="label">
          <label [for]="enum.active">Visible</label>
        </div>
        <div class="input">
          @if (saveButton) {
          <p-toggleButton
            formControlName="active"
            onLabel="Visible"
            offLabel="No Visible"
          />
          } @else if ((value() !== undefined) && details()) {
          {{ value()?.formattedActive }}
          }
        </div>
        <div class="button"></div>
      </li>
      <!-- <li>
        <div class="label">
          <label [for]="enum.active">Fecha de inicio</label>
        </div>
        <div class="input">
          @if (saveButton) {
          <p-calendar
            formControlName="start_date"
            [showClear]="true"
            [showIcon]="true"
            [iconDisplay]="'input'"
          />
          } @else if ((value() !== undefined) && details()) {
          {{ value()?.formattedStartDate }}
          }
        </div>
        <div class="button"></div>
      </li>
      <li>
        <div class="label">
          <label [for]="enum.active">Fecha de fin</label>
        </div>
        <div class="input">
          @if (saveButton) {
          <p-calendar formControlName="end_date" />
          } @else if ((value() !== undefined) && details()) {
          {{ value()?.formattedEndDate }}
          }
        </div>
        <div class="button"></div>
      </li> -->
      @if (value()?._id && access()?.contract?.actions?.read) {
      <li>
        <div class="label">
          <label>Creador de la Campaña</label>
        </div>
        <div class="input">
          {{ value()?.formattedCreatedBy }}
        </div>
        <div class="button"></div>
      </li>
      <li>
        <div class="label">
          <label>Fecha de <br />Creacion de la <br />Campaña</label>
        </div>
        <div class="input">
          {{ value()?.formattedCreatedAt }}
        </div>
        <div class="button"></div>
      </li>
      }
    </ul>
  </div>
</app-resource-form-card>

<p-dialog header="hola" [modal]="true" [(visible)]="uploadvisible">
  @defer (on viewport) {
  <app-images-crate><div>hola estoy aqui</div></app-images-crate>
  } @placeholder {
  <div>Cargando</div>
  }
</p-dialog>
